import React from "react";
import { Reveal } from "./Motion";
type PainBlockProps = {
  title: string;
  paragraphs: ReadonlyArray<string>;
};
export function PainBlock({
  title,
  paragraphs
}: PainBlockProps) {
  return <Reveal data-id="element-22" data-mp="1fysy6e6od3v5">
      <article className="border-t border-stone-200 py-5 lg:py-7" data-id="element-23" data-mp="1fy9eot1dm7f0">
        <h3 className="max-w-3xl text-xl font-extrabold uppercase leading-[1.08] tracking-[-0.04em] text-stone-950 sm:text-2xl" data-id="element-24" data-mp="1k0nypggs7d7v">{title}</h3>
        <div className="mt-3 max-w-3xl space-y-2.5 text-[15px] leading-relaxed text-stone-600 sm:text-base" data-id="element-25" data-mp="1oz7l1hzaer0r">
          {paragraphs.map(paragraph => <p key={paragraph} data-id="element-26" data-mp="1twr0gl7q19ua">{paragraph}</p>)}
        </div>
      </article>
    </Reveal>;
}